module.exports = __webpack_public_path__ + "static/media/incentive.ac636e85.png";